module.exports = __webpack_public_path__ + "img/banner.3e967043.png";